(function () {
  var STORAGE_KEY = 'drRecentlySeenProducts';
  var DEFAULT_MAX_ITEMS = 8;
  var DEFAULT_MIN_ITEMS = 2;
  var CARD_SECTION_ID = 'dr-recently-seen-card';

  function parsePositiveInt(value, fallback) {
    var parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : fallback;
  }

  function normalizeHandle(value) {
    if (typeof value !== 'string') return '';
    return value.trim().toLowerCase();
  }

  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed.map(normalizeHandle).filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function writeHistory(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (error) {
      // Ignore storage write failures (private mode/storage limits).
    }
  }

  function upsertHandle(handle, maxItems) {
    var normalized = normalizeHandle(handle);
    if (!normalized) return;

    var current = readHistory().filter(function (item) {
      return item !== normalized;
    });
    current.unshift(normalized);
    writeHistory(current.slice(0, maxItems));
  }

  function getRecentHandles(maxItems) {
    var seen = new Set();
    var deduped = [];

    readHistory().forEach(function (handle) {
      if (!seen.has(handle)) {
        seen.add(handle);
        deduped.push(handle);
      }
    });

    return deduped.slice(0, maxItems);
  }

  function fetchCardMarkup(handle) {
    var url = '/products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION_ID;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return '';
        return response.text();
      })
      .then(function (htmlText) {
        if (!htmlText) return '';
        var parser = new DOMParser();
        var doc = parser.parseFromString(htmlText, 'text/html');
        var card = doc.querySelector('[data-dr-recent-card]');
        return card ? card.outerHTML : '';
      })
      .catch(function () {
        return '';
      });
  }

  function getSectionContainerById(sectionId) {
    if (!sectionId) return null;
    return document.querySelector('[id$="__' + sectionId + '"]');
  }

  function setSectionVisibility(sectionId, isVisible) {
    var container = getSectionContainerById(sectionId);
    if (!container) return;
    container.hidden = !isVisible;
  }

  function initializeTracker() {
    var trackers = document.querySelectorAll('[data-dr-component="recentlySeenTracker"]');
    trackers.forEach(function (tracker) {
      var maxItems = parsePositiveInt(tracker.dataset.maxItems, DEFAULT_MAX_ITEMS);
      var handle = normalizeHandle(tracker.dataset.productHandle);
      if (handle) upsertHandle(handle, maxItems);
    });
  }

  function initializeCarousel() {
    var carousels = document.querySelectorAll('[data-dr-component="recentlySeenCarousel"]');

    carousels.forEach(function (carousel) {
      var list = carousel.querySelector('.product-grid');
      if (!list) return;

      var maxItems = parsePositiveInt(carousel.dataset.maxItems, DEFAULT_MAX_ITEMS);
      var minItems = parsePositiveInt(carousel.dataset.minItems, DEFAULT_MIN_ITEMS);
      var fallbackSectionId = carousel.dataset.fallbackSectionId || '';
      var handles = getRecentHandles(maxItems);

      if (handles.length < minItems) {
        carousel.hidden = true;
        setSectionVisibility(fallbackSectionId, true);
        return;
      }

      Promise.all(
        handles.map(function (handle) {
          return fetchCardMarkup(handle);
        })
      ).then(function (cards) {
        var validCards = cards.filter(Boolean);

        if (validCards.length < minItems) {
          carousel.hidden = true;
          setSectionVisibility(fallbackSectionId, true);
          return;
        }

        list.innerHTML = validCards.join('');
        carousel.hidden = false;
        setSectionVisibility(fallbackSectionId, false);

        if (window.drCardCouponPill && typeof window.drCardCouponPill.refresh === 'function') {
          window.drCardCouponPill.refresh();
        }
      });
    });
  }

  function init() {
    initializeTracker();
    initializeCarousel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
    return;
  }

  init();
})();
